import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { LocationsHttpClient } from '../locations-http-client';
import { RegionActions } from './regions.store';

@Injectable({ providedIn: 'root' })
export class RegionEffects {
  public effects = createEffectFactory(RegionActions, this.actions$);

  public fetchRegions$ = this.effects(
    RegionActions.fetchOne,
    ({ payload }) =>
      this.locationsHttpClient
        .fetchRegions(payload.id.toString())
        .pipe(map(regions => ({ data: { id: payload.id.toString(), regions } }))),
    { customMapOperator: mergeMap },
  );

  constructor(private locationsHttpClient: LocationsHttpClient, private actions$: Actions) {}
}
